import { deleteRequest, getRequest, putRequest } from '../api-handler';
import { MixtureDetailDto, MixtureProductDto } from './mixture';

export const MixtureApi = {
  getById: (id: number) => getRequest<MixtureDetailDto>(`/mixtures/${id}`),
  addMixtureProduct: (
    id: number,
    productId: number,
    amount: Nullable<number>
  ) =>
    putRequest(`/mixtures/${id}/product/${productId}/add`, {
      id: id,
      productId: productId,
      amount: amount
    }),
  removeMixtureProduct: (id: number, mixtureProduct: MixtureProductDto) =>
    putRequest(
      `/mixtures/${id}/product/${mixtureProduct.productId}/remove`,
      mixtureProduct
    ),
  deleteMixtureProduct: (id: number, mixtureProduct: MixtureProductDto) =>
    deleteRequest(`/mixtures/${id}/product/${mixtureProduct.productId}`),
  getMixtureProductParameters: (mixtureId: number, parameterSetId: number) =>
    getRequest<MixtureProductDto[]>(
      `/mixtures/${mixtureId}/productparameters/${parameterSetId}`
    )
};
